"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONService = void 0;
const JSONParse = require("json-parse-safe");
class JSONService {
    parse(stringJson) {
        const jsonSafe = JSONParse(stringJson);
        if (!jsonSafe.value || jsonSafe.error) {
            if (jsonSafe.error) {
                // tslint:disable-next-line
                console.warn(jsonSafe.error.message);
            }
            return null;
        }
        return jsonSafe.value;
    }
}
const service = new JSONService();
exports.JSONService = service;
